(() => {
  if (window.dwStickyBuyInstalled) return;
  window.dwStickyBuyInstalled = true;
  let scheduled = false;
  const install = () => {
    scheduled = false;
    document.querySelectorAll('product-quick-add[form]').forEach(bar => {
      if (bar.dataset.dwEnhanced) return;
      const form = document.getElementById(bar.getAttribute('form'));
      const group = bar.querySelector('buy-buttons.sm\\:hidden');
      const button = group?.querySelector('button[type="submit"]');
      if (!form || !group || !button) return;
      let source = form.elements.namedItem('quantity');
      if (!source || !('value' in source)) {
        source = document.createElement('input');
        source.type = 'hidden'; source.name = 'quantity'; source.value = '1';
        form.append(source);
      }
      bar.dataset.dwEnhanced = 'true';
      bar.classList.add('dw-sticky-buy');
      group.classList.add('dw-sticky-buy__controls');
      const price = document.createElement('span');
      price.className = 'dw-sticky-buy__price';
      const priceText = element => {
        if (!element) return '';
        const copy = element.cloneNode(true);
        copy.querySelectorAll('.sr-only').forEach(el => el.remove());
        return copy.textContent.trim();
      };
      const sale = bar.querySelector('.product-quick-add__variant sale-price');
      const compare = bar.querySelector('.product-quick-add__variant compare-at-price');
      const currentText = priceText(sale);
      const oldText = priceText(compare);
      if (oldText && currentText) {
        const oldPrice = document.createElement('s');
        oldPrice.className = 'dw-sticky-buy__old-price';
        oldPrice.setAttribute('aria-label', 'Oude prijs ' + oldText);
        oldPrice.textContent = oldText;
        price.append(oldPrice);
      }
      if (currentText) {
        const currentPrice = document.createElement('span');
        currentPrice.className = 'dw-sticky-buy__current-price';
        currentPrice.setAttribute('aria-label', 'Prijs ' + currentText);
        currentPrice.textContent = currentText;
        price.append(currentPrice);
      }
      const quantity = document.createElement('div');
      quantity.className = 'dw-sticky-buy__quantity';
      const minus = document.createElement('button');
      minus.type = 'button'; minus.textContent = '−'; minus.setAttribute('aria-label', 'Aantal verlagen');
      const input = document.createElement('input');
      input.type = 'number'; input.inputMode = 'numeric'; input.setAttribute('aria-label', 'Aantal');
      const plus = document.createElement('button');
      plus.type = 'button'; plus.textContent = '+'; plus.setAttribute('aria-label', 'Aantal verhogen');
      quantity.append(minus, input, plus);
      group.prepend(price, quantity);
      const sync = () => {
        input.min = source.min || '1'; input.step = source.step || '1'; input.max = source.max || '';
        input.value = source.value || input.min;
        const value = Number(input.value), step = Number(input.step);
        minus.disabled = value - step < Number(input.min);
        plus.disabled = input.max !== '' && value + step > Number(input.max);
      };
      const commit = () => {
        if (!input.checkValidity()) { input.reportValidity(); sync(); return; }
        source.value = input.value;
        source.dispatchEvent(new Event('input', { bubbles: true }));
        source.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      };
      minus.addEventListener('click', () => { input.stepDown(); commit(); });
      plus.addEventListener('click', () => { input.stepUp(); commit(); });
      input.addEventListener('change', commit);
      source.addEventListener('change', sync);
      button.addEventListener('click', event => {
        if (!input.checkValidity()) { event.preventDefault(); input.reportValidity(); }
        else commit();
      });
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        if (/Toevoegen aan winkelwagen/.test(walker.currentNode.textContent)) {
          walker.currentNode.textContent = 'In winkelwagen'; break;
        }
      }
      sync();
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(install);
  };
  const start = () => {
    install();
    new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
        (node.matches?.('product-quick-add, product-rerender, buy-buttons') || node.querySelector?.('product-quick-add'))))) schedule();
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
